module.exports = __webpack_public_path__ + "img/free-sell.b02140e.svg";